// extracted by mini-css-extract-plugin
export default {"event":"events_event__xgnZ9","eventsGrid":"events_eventsGrid__ilQ5F","thumb":"events_thumb__7kYQQ","title":"events_title__9mKLi"};